import {
  HeaderInformation,
  AEAStepper,
  AEAStep,
  BasicDataFE,
  ImplementersFE,
  ObjetiveFE,
  GeneralSummeryFE,
  CounterpartsFE
} from "@components/";
import { FormProaFEPresenter } from "@presenters/screens/form-proa-fe.presenter";
import React, { FC, useEffect, useState } from 'react'
import { Container, Row } from "reactstrap";
import ZonaAdtFE from "./zona-adt/zona-adt-fe";
import { IFormProaFE } from "@interfaces/screens/form-proa-fe.interface";
import { Utilities } from '@utils';

export interface IFormProaFEProps {
  dataColumns: any;
  subventionCodeId: number;
  index: number;
  grantCode: string;
  projectsGrouped: any;
  forceLoad: boolean;
}

const FormProaFE: FC<IFormProaFEProps> = (props) => {
  const [headerInfo, setHeaderInfo] = useState(null);
  const [switchForm, setSwitchForm] = useState(false);
  const [step1, setStep1] = useState<any>();
  const [step2, setStep2] = useState<any>();
  const [step3, setStep3] = useState<any>();
  const [stepSDC, setStepSDC] = useState<any>();
  const [step4, setStep4] = useState<any>();
  const [step4MRI, setStep4MRI] = useState<any>();

  const view: IFormProaFE = {
    state: {
      subventionCodeId: props.subventionCodeId,
      grantCode: props.grantCode,
      headerInfo: headerInfo,
      dataColumns: props.dataColumns,
      step1: step1,
      setHeaderInfo: setHeaderInfo,
      startDate: step1?.genericInfo?.OCTAVIAFechaInicio,
      setStep1: setStep1
    },
    step1Data: step1,
    step2Data: step2,
    stepSDCData: stepSDC,
    step3Data: step3,
    step4MRIData: step4MRI,
    step4Data: step4,
    endDate: step1?.genericInfo?.OCTAVIAFechaFinalizacion || null,
  }
  const presenter = new FormProaFEPresenter(view);

  const handleSwitch = () => {
    presenter.unSetLoading()
    setSwitchForm(switchForm => !switchForm) 
  }

  useEffect(() => {
    presenter.initializeHeaderInformation(props.projectsGrouped);
  }, [presenter.currentBudget, presenter.currentLabels, presenter.formMasters, props.projectsGrouped]);

  if (Utilities.isNullEmptyObject(props.dataColumns)) return <div></div>;

  let alertEndDate = presenter.validEndDate()

  return (
    <Container fluid={true}>
      <Row>
        <HeaderInformation data={headerInfo}></HeaderInformation>
        <AEAStepper
          activeAll={false}
          defaultStep={presenter.currentLabels.get("Datos básicos")}
          activateValidation={false}
          errorSelectors={[".dx-invalid"]}
        >
          <AEAStep title={presenter.currentLabels.get("Datos básicos")}>
            <BasicDataFE
              alertEndDate={alertEndDate}
              dataColumns={props.dataColumns}
              index={props.index}
              step1={step1}
              setStep1={setStep1}
              switchForm={switchForm}
              files={step1?.files}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
              subventionCodeId={props.subventionCodeId}
              grantCode={props.grantCode}
              headerInfo={view.state.headerInfo}
              handleSwitch={handleSwitch}
            ></BasicDataFE>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("Implementadores")}>
            <ImplementersFE
              alertEndDate={alertEndDate}
              dataColumns={props.dataColumns}
              index={props.index}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
              subventionCodeId={props.subventionCodeId}
              grantCode={props.grantCode}
              step2={step2}
              switchForm={switchForm}
              setStep2={setStep2}
              handleSwitch={handleSwitch}
            ></ImplementersFE>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("PProaContrapartidas")}>
            <CounterpartsFE
              alertEndDate={alertEndDate}
              dataColumns={props.dataColumns}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
              subventionCodeId={props.subventionCodeId}
              grantCode={props.grantCode}
              projectsGrouped={props.projectsGrouped}
              index={props.index}
              handleSwitch={handleSwitch}
              step2={step2}
              stepSDC={stepSDC}
              switchForm={switchForm}
              setStepSDC={setStepSDC}
            ></CounterpartsFE>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("ZONACCAA")}>
            <ZonaAdtFE
              alertEndDate={alertEndDate}
              dataColumns={props.dataColumns}
              index={props.index}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
              subventionCodeId={props.subventionCodeId}
              grantCode={props.grantCode}
              switchForm={switchForm}
              handleSwitch={handleSwitch}
              step3={step3}
              setStep3={setStep3}
            ></ZonaAdtFE>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("proaResultadosIntermedios")} >
            <ObjetiveFE
              alertEndDate={alertEndDate}
              index={props.index}
              switchForm={switchForm}
              step1={step1}
              step4={step4}
              setStep4={setStep4}
              step4MRI={step4MRI}
              setStep4MRI={setStep4MRI}
              subventionCodeId={props.subventionCodeId}
              dataColumns={props.dataColumns}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
              handleSwitch={handleSwitch}
            ></ObjetiveFE>
          </AEAStep>
          <AEAStep title={presenter.currentLabels.get("proaFFRRConsolidadoResultadosIntermedios")} >
            <GeneralSummeryFE
              step2={step2}
              step3={step3}
              step4={step4}
              stepSDC={stepSDC}
              switchForm={switchForm}
              dataColumns={props.dataColumns}
              index={props.index}
              startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
              endDate={step1?.genericInfo?.OCTAVIAFechaFinalizacion || null}
            ></GeneralSummeryFE>
          </AEAStep>
        </AEAStepper>
      </Row>
    </Container>
  );
};

export default FormProaFE;
